// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'sale-payment.page.title': 'Sale Payments',
    'sale-payment.page.create.title': 'Record Payment',
    'sale-payment.page.edit.title': 'Edit Sale Payment',
    'sale-payment.page.title.redo': 'Redo Payment',

    'sale-payment.button.cancel': 'Cancel',
    'sale-payment.button.create': 'Complete Sale',
    'sale-payment.button.new': 'Record Payment',
    'sale-payment.button.save': 'Save Changes',
    'sale-payment.button.refund': 'Refund Payment',
    'sale-payment.button.payments': 'Payment History',
    'sale-payment.button.void': 'Void Payment',
    'sale-payment.button.rollback': 'Rollback Payment',
    'sale-payment.button.redo': 'Redo',

    'sale-payment.placeholder.search': 'Search sale payments',

    'sale-payment.link.sale_payments': ' Return to Sale Payments',
    'sale-payment.link.retry': 'Click here to retry',

    'sale-payment.message.no_payment': 'No payment has been recorded as yet.',

    'sale-payment.label.transaction_date': 'Transaction Date',
    'sale-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'sale-payment.label.is_reconciled': 'Is Reconciled',
    'sale-payment.label.payment_method': 'Payment Method',
    'sale-payment.label.reference_code': 'Reference Code',
    'sale-payment.label.memo': 'Memo',
    'sale-payment.label.fx_currency_name': 'Currency',
    'sale-payment.label.currency_amount_in_cents': 'Transaction Amount',
    'sale-payment.label.cancelled_on': 'Cancelled On',
    'sale-payment.label.cancellation_reason': 'Cancellation Reason',
    'sale-payment.label.reason_for_void': 'Reason for voiding',
    'sale-payment.label.rollback_reason': 'Reason for rollback',
    'sale-payment.label.refund_reason': 'Reason for refund',
    'sale-payment.label.issue_credit_memo': 'Give store credit?',
    'sale-payment.label.status': 'Status',

    'sale-payment.modal.title.sale_payment_void': 'Void Payment',
    'sale-payment.modal.title.sale_payment_refund': 'Refund Payment',
    'sale-payment.modal.title.sale_payment_rollback': 'Rollback Payment',

    'sale-payment.success.message.sale_payment_created': 'Your sale payment has been created',
    'sale-payment.success.message.sale_payment_updated': 'Your sale payment has been updated',
    'sale-payment.success.message.sale_payment_voided': 'Your sale payment has been voided',
    'sale-payment.success.message.sale_payment_refunded': 'Your sale payment has been refunded',
    'sale-payment.success.message.sale_payment_rolled_back': 'Your sale payment has been rolled back',
    'sale-payment.success.message.sale_payment_redone': 'Your sale payment has been redone',

    'sale-payment.error.message.error_loading_page': 'Sorry, there was an error loading sale payment.| Sorry, there was an error loading sale payments.',
};
